import httpClient from "@/config/httpClient";

export async function fetchMe() {
	const { isError, response, status } = await httpClient.get("/auth/me");

	return {
		success: !isError,
		me: response,
		status,
	};
}
